function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import AvatarFallback from '@strava/icons/NavigationProfileHighlightedMedium';
import EmployeeBadge from '@strava/icons/BadgesMulticolorSuperuserSmall';
import SubscriberBadge from '@strava/icons/BadgesMulticolorSummitSmall';
import ProBadge from '@strava/icons/BadgesMulticolorProSmall';
import VerifiedBadge from '@strava/icons/BadgesMulticolorVerifiedSmall';
import styles from './styles.scss';

var Img = function Img(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      title = _ref.title,
      fallback = _ref.fallback;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      children = _useState2[0],
      setChildren = _useState2[1];

  useEffect(function () {
    var image = new Image();

    image.onload = function () {
      setChildren( /*#__PURE__*/React.createElement("img", {
        src: src,
        alt: alt,
        title: title
      }));
    };

    image.onerror = function () {
      setChildren(fallback);
    };

    image.src = src;
  }, [src]);
  return children;
};

Img.defaultProps = {
  fallback: null
};

function getBadge(badge) {
  switch (badge) {
    case 'ambassador':
      return /*#__PURE__*/React.createElement(ProBadge, null);

    case 'employee':
      return /*#__PURE__*/React.createElement(EmployeeBadge, null);

    case 'subscriber':
    case 'premium':
      return /*#__PURE__*/React.createElement(SubscriberBadge, null);

    case 'pro':
      return /*#__PURE__*/React.createElement(ProBadge, null);

    case 'verified':
      return /*#__PURE__*/React.createElement(VerifiedBadge, null);

    default:
      return null;
  }
}

var Avatar = function Avatar(_ref2) {
  var name = _ref2.name,
      type = _ref2.type,
      src = _ref2.src,
      size = _ref2.size,
      badge = _ref2.badge,
      href = _ref2.href,
      classNameProp = _ref2.className,
      otherProps = _objectWithoutProperties(_ref2, ["name", "type", "src", "size", "badge", "href", "className"]);

  var classNames = [styles.avatar, styles[type]];

  if (styles[size]) {
    classNames.push(styles[size]);
  }

  if (classNameProp) {
    classNames.push(classNameProp);
  }

  var children = /*#__PURE__*/React.createElement(React.Fragment, null, badge && /*#__PURE__*/React.createElement("div", {
    className: styles.badge
  }, getBadge(badge)), /*#__PURE__*/React.createElement("div", {
    className: styles.imgWrapper
  }, /*#__PURE__*/React.createElement(Img, {
    src: src,
    alt: name,
    title: name,
    fallback: type === 'athlete' ? /*#__PURE__*/React.createElement(AvatarFallback, null) : null
  })));

  if (href) {
    return /*#__PURE__*/React.createElement("a", Object.assign({
      href: href,
      className: classNames.join(' ')
    }, otherProps), children);
  }

  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classNames.join(' ')
  }, otherProps), children);
};

Avatar.defaultProps = {
  href: null,
  size: null,
  badge: null,
  className: null
};
export default Avatar;